export default __webpack_public_path__ + "static/media/profile-menu-icon.efd05865.svg";